import React, {Component} from "react";
import {AssignBusinessUnitLabelsButton} from "../../AssignBusinessUnitLabelsButton";

export class DashboardLabelsCell extends Component {
    render() {
        return (
            <td className="label-cell">
                <div className="label-cell-display">
                    {this.props.data.map(label =>
                        <div className="react-tagsinput-tag" key={label}>{label}</div>
                    )}
                </div>
                <AssignBusinessUnitLabelsButton
                    businessUnitName={this.props.businessUnitName}
                    businessUnitLabels={this.props.data}
                    businessUnitId={this.props.businessUnitId}
                    onLabelsChange={this.props.onLabelsChange}
                />
            </td>
        );
    }
}